import React, { useState,useEffect } from 'react';
import WarehouseStatusDatatable from './WarehouseStatusDatatable';




const WarehouseStatusTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
  

    const handleCallback = (id) => {
          setRecordId(id);       
        
    };
 
 
    useEffect(() => {      
      setRecordId(props.selectedRecord);
    }, [props.selectedRecord])
  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <WarehouseStatusDatatable            
            parentCallback={handleCallback}    
            warehouseId={recordId}                           
          />
                 
        </div>
    );
};

export default WarehouseStatusTab;